/*
 * @Author: changcheng
 * @LastEditTime: 2022-10-17 16:54:16
 */
import { Divider } from "antd";
import { BarChart } from "../components/barChart";
import {
  getRecipientUserDataManage,
  getRecipientTrainDataManage,
  getRecipientLearnView,
  exportRecipientUserDataManage,
  exportRecipientLearnView,
  exportRecipientTrainDataManage,
} from "@root/common/service";
import { useEffect, useState } from "react";

export interface EchartHostitalDataProps {
  averageWatchTime: number;
  learnRatio: number;
  learnRatioText: string;
  learnUserCount: number;
  subjectId: number;
  subjectName: string;
  userCount: number;
  watchTime: number;
}
export interface EchartUserDataProps {
  learnUserCount: number;
  subjectId: number;
  subjectName: string;
  userCount: number;
}
export interface EchartTrainDataProps {
  learnRatio: number;
  learnRatioText: string;
  learnUserCount: number;
  subjectId: number;
  subjectName: string;
  userCount: number;
}
const China = () => {
  const [hospitalChartData, setHospitalChartData] = useState<[]>([]);
  const [learningChartData, setLearningChartData] = useState<[]>([]);
  const [percentOfPassData, setPercentOfPassData] = useState<[]>([]);
  async function getOverAllOverViewData(subject?: number | undefined) {
    const { data: hospitalData } = await getRecipientUserDataManage({
      subjectId: subject,
    });
    const { data: userData } = await getRecipientLearnView({
      subjectId: subject,
    });
    const { data: trainData } = await getRecipientTrainDataManage({
      subjectId: subject,
    });

    const initHospitalData: [] = hospitalData.map(
      (item: EchartHostitalDataProps) => {
        return [item.subjectName, item.watchTime, item.averageWatchTime];
      }
    );
    const initLearningData: [] = userData.map((item: EchartUserDataProps) => {
      return [item.subjectName, item.userCount, item.learnUserCount];
    });
    const initPercentData: [] = trainData.map((item: EchartTrainDataProps) => {
      return [item.subjectName, item.learnRatio];
    });

    setHospitalChartData(initHospitalData);
    setLearningChartData(initLearningData);
    setPercentOfPassData(initPercentData);
  }
  useEffect(() => {
    getOverAllOverViewData();
  }, []);
  const onSelectChangeHandle = (value: any) => {
    if (value === "all") {
      value = undefined;
    }

    getOverAllOverViewData(value);
  };
  return (
    <div>
      <Divider />
      <BarChart
        id="hospital"
        subtitle="单位：小时"
        dimensions={["学习时长", "平均学习时长"]}
        sources={hospitalChartData}
        exportPost={exportRecipientUserDataManage}
        exportFileName="受援医院学习时长和平均学习时长"
      />
      <BarChart
        id="learning"
        subtitle="单位：人"
        dimensions={["注册人数", "学习人数"]}
        sources={learningChartData}
        exportPost={exportRecipientLearnView}
        exportFileName="受援医院注册人数和人数"
      />
      <BarChart
        id="percent"
        subtitle="单位：%"
        dimensions={["培训率"]}
        sources={percentOfPassData}
        exportPost={exportRecipientTrainDataManage}
        exportFileName="受援医院培训率"
      />
    </div>
  );
};

export default China;
